import { useMutation } from '@tanstack/react-query';
import { useToast } from '@client/components/hooks/use-toast';
import { anonymousPuiApi } from '@client/api/waterlily';

interface useSendPuiEmailProps {
  onSuccess: (emailResults: PostAnonymousPuiEmailResponse) => void;
}

export function useSendPuiEmail({ onSuccess }: useSendPuiEmailProps) {
  const { toast } = useToast();

  const mutation = useMutation({
    mutationFn: (params: PostAnonymousPuiEmailRequestParams) => anonymousPuiApi.postEmail(params),
    onSuccess: (data: PostAnonymousPuiEmailResponse) => onSuccess(data),
    onError: (error: Error) => {
      toast({
        title: 'Failed to send anonymous PUI request',
        description: error?.message || 'An unexpected error occurred. Please try again.',
        variant: 'destructive',
        duration: 10000,
      });
    },
  });

  return {
    ...mutation,
  };
}
